/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_SourceInputs */



/**
* | output |
* | --- |
* | "Media Source" |
*
* @param {Media_SourceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_source = /** @type {((inputs?: Media_SourceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_SourceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Source média")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienquelle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fonte multimediale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Источник информации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fuente de medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体来源")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアソース")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया स्रोत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fonte de mídia")
	return /** @type {LocalizedString} */ ("Media Source")
});